import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="py-10 px-4" data-id="element-71">
      <div className="max-w-xl mx-auto" data-id="element-72">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white border-2 border-brand-swiss-red/30 p-6 sm:p-8 rounded-2xl text-center shadow-sm" data-id="element-73">
          <ShieldCheckIcon className="w-12 h-12 text-brand-swiss-red mx-auto mb-3" data-id="element-74" />
          <h3 className="text-xl sm:text-2xl font-black text-brand-charcoal uppercase mb-3" data-id="element-75">
            🛡️ 7-Tage-Zufriedenheitsgarantie
          </h3>
          <p className="text-gray-700 text-[14px] sm:text-base font-medium leading-relaxed" data-id="element-76">
            Wir sind von der Qualität unseres Systems überzeugt. Wenn Sie
            innerhalb von 7 Tagen nach dem Kauf nicht vollständig zufrieden
            sind, erstatten wir Ihnen den vollen Betrag. Ohne Fragen. Ohne
            Formulare. Ohne Risiko. 🇨🇭
          </p>
        </motion.div>
      </div>
    </section>;
}